export default (tags: string[]): { [key: string]: string } => {
  if (Array.isArray(tags)) {
    const tagFields = tags.reduce((fields, tag) => {
      if (tag.includes('field::')) {
        const [, key, value] = tag.split('::')
        fields[key] = value
      }

      return fields
    }, {} as { [key: string]: string })

    return {
      ...tagFields
    }
  }

  return {}
}
